import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "reduxFiles/hooks";
import { UserRole } from "types/userTypes";
import { BiBuilding, BiBuildings } from "react-icons/bi";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const PanelSwitcher = () => {
  const { user } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (
    user?.role !== UserRole.USER ||
    !user?.organization ||
    user.companyCount === 0
  ) {
    return null;
  }

  const isCompany = location.pathname.startsWith("/company");

  const isOrganization = location.pathname.startsWith("/organization");

  const handleSwitch = (path: string) => {
    navigate(path);
  };

  return (
    <div className="relative flex items-center rounded-full bg-gray-100 p-1 dark:bg-navy-900 ltr:flex-row-reverse">
      <button
        onClick={() => handleSwitch("/company/dashboard")}
        className={`relative flex min-w-[40px] items-center justify-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium ${
          isCompany ? "text-white" : "text-gray-600"
        }`}
      >
        <BiBuilding className="relative z-10 h-4 w-4" />
        <span className="relative z-10 hidden md:block">
          {t("common.company")}
        </span>
      </button>

      <button
        onClick={() => handleSwitch("/organization/dashboard")}
        className={`relative flex min-w-[40px] items-center justify-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium ${
          isOrganization ? "text-white" : "text-gray-600"
        }`}
      >
        <BiBuildings className="relative z-10 h-4 w-4" />
        <span className="relative z-10 hidden md:block">
          {t("common.organization")}
        </span>
      </button>

      <motion.div
        className="absolute bottom-1 top-1 rounded-full bg-brand-500"
        animate={{
          x: isCompany ? 0 : "-100%",
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 35,
        }}
        style={{
          width: "calc(50% - 4px)",
        }}
      />
    </div>
  );
};
